import React from "react";
import { observer, inject } from "mobx-react";
import ListDataProvider from "../../toolkit/mobx-connectors/ListDataProvider";
import DataTable from "../../toolkit/DataTable/DataTable";
import { withStyles } from "@material-ui/core/styles";
import axios from "../../utils/axios";
import Filter from "../../utils/filter";
import createParams from "../../utils/filter-params";
import snackbarStore from "../../stores/snackbar-store";
import TableCell from "@material-ui/core/TableCell";

class Diccionario extends React.Component {
  state = {
    dataset: {}
  };

  getSettings() {
    return {
      atributo: {
        label: "Atributo",
        sortable: false,
        filterable: true,
        type: "string",
        cellRendering: item => (
          <TableCell>
            <strong>{item.atributo}</strong>
          </TableCell>
        )
      },
      descripcion: {
        label: "Descripción",
        sortable: false,
        filterable: true,
        type: "string"
      },
      tipoDato: {
        label: "Tipo de Dato",
        sortable: false,
        filterable: true,
        type: "string"
      },
      restricciones: {
        label: "Restricciones",
        sortable: false,
        filterable: true,
        type: "string"
      },
      referencia: {
        label: "Referencia",
        sortable: false,
        filterable: true,
        type: "string"
      },
      ejemplo: {
        label: "Ejemplo",
        sortable: false,
        filterable: true,
        type: "string"
      }
    };
  }

  onReloadTable() {
    let settings = this.getSettings();
    let params = createParams({ ...this.props.diccionario.list, settings });
    const datasetLink = this.props.match.params.dataset;

    let datasetParams = Filter.path('link').eq(datasetLink);

    axios
      .get(`dataset`, {
        data: {},
        datasetParams
      })
      .then(resp => {
        this.setState({
          dataset: resp.data.data[0]
        })
        this.getDiccionario(resp.data.data[0].id, params);
      }
      )
      .catch(() => {
        snackbarStore.openSnackbar("Error al obtener el dataset", "error");
      });
  }

  getDiccionario(id, params){
    if (params.filter) {
      params.filter.and(Filter.path('datasets.id').eq(id));
      params.filter = JSON.stringify(params.filter);
    } else {
      params.filter = JSON.stringify(Filter.path('datasets.id').eq(id));
    }
    axios
    .get(`diccionario`, {
      data: {},
      params
    })
    .then(resp => {
      this.props.diccionario.list.dataLoaded(resp.data.data, {
        currentPage: resp.data.meta.currentPage - 1,
        pageSize: resp.data.meta.pageSize,
        itemsCount: resp.data.meta.total
      })
    }
    )
    .catch(() => {
      snackbarStore.openSnackbar("Error al obtener los diccionario", "error");
    });
  }

  render() {

    const { classes } = this.props;

    return (
      <React.Fragment>
        <div className={classes.layout}>
          <ListDataProvider
            listStore={this.props.diccionario.list}
            render={listProps => (
              <DataTable
                title={this.state.dataset.nombre ? this.state.dataset.nombre: ''}
                settings={this.getSettings()}
                onReloadTable={() => this.onReloadTable()}
                {...listProps}
              />
            )}
          />
        </div>
      </React.Fragment>
    );
  }
}

const styles = theme => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(1100 + theme.spacing(3) * 2)]: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  }
});

export default withStyles(styles)(inject("diccionario")(observer(Diccionario)));
